import script from "./GloablHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./GloablHeader.vue?vue&type=script&setup=true&lang=ts"

import "./GloablHeader.vue?vue&type=style&index=0&id=5ab3c47b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ab3c47b"]])

export default __exports__